import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { usePageVisible } from '@/hooks/usePageVisible';
import { useUserRole } from '@/hooks/useUserRole';

export interface PostgresLog {
  id: string;
  timestamp: number;
  error_severity: string;
  event_message: string;
  identifier: string;
}

export function useSystemLogs(severity?: string) {
  const { isAdmin } = useUserRole();
  const visible = usePageVisible();

  return useQuery({
    queryKey: ['system-logs', severity],
    enabled: isAdmin,
    refetchInterval: isAdmin && visible ? 60_000 : false,
    queryFn: async () => {
      let query = `
        SELECT identifier, postgres_logs.timestamp, id, event_message, parsed.error_severity
        FROM postgres_logs
        CROSS JOIN UNNEST(metadata) AS m
        CROSS JOIN UNNEST(m.parsed) AS parsed
      `;

      if (severity && severity !== 'all') {
        query += ` WHERE parsed.error_severity = '${severity}'`;
      }

      query += ` ORDER BY timestamp DESC LIMIT 100`;

      const { data, error } = await supabase.rpc('supabase--analytics-query' as any, {
        query,
      }) as any;

      if (error) throw error;
      return data || [];
    },
  });
}
